import { languageName, useLanguageStore } from '@/stores/language-store'
import { isClearlySpanish } from './language-detect'

/** The slice of the companion manager the flip must reach directly. */
export interface LanguageTarget {
  setLanguage(languageName: string, forced?: boolean): void
  detectedLanguage?: string
}

/**
 * Call with the trader's own words BEFORE a turn is sent. When they are clearly
 * Spanish and the option is not Spanish yet, the option flips (persisted, with a
 * notice) and the manager is set in the same tick: app-layout mirrors the store
 * into the manager in an effect that has not run yet when the send follows, so
 * without this the first Spanish turn would still carry the English prompt.
 */
export function followSpanishQuestion(text: string, manager: LanguageTarget): boolean {
  if (useLanguageStore.getState().language === 'es' || !isClearlySpanish(text)) return false
  useLanguageStore.getState().adoptDetectedLanguage('es')
  manager.setLanguage(languageName('es'), true)
  manager.detectedLanguage = 'es'
  return true
}
